import Vue from 'vue'
import resize from '@/directives/v-el-resize.js'
export default function (app) {
  Vue.directive('el-resize', resize)
}
